import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LayoutModule } from './modules/layout/layout.module';
import { AuthModule } from './modules/auth/auth.module';
import { SettingsModule } from './modules/settings/settings.module';
import { SettingsService } from '@modules/settings/services/settings.service';

@Component({
    selector: 'app-root',
    imports: [
        RouterOutlet,
        LayoutModule,
        AuthModule,
        SettingsModule,
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.less'
})
export class AppComponent {
  title = 'Road Runner';

  /**
   * Constructor
   */

  constructor(
    private settingsService: SettingsService,
  ) {
    this.settingsService.setup();
  }
}
